import { render } from "./ApplicationHotspot.vue?vue&type=template&id=707e1cfa"
import script from "./ApplicationHotspot.vue?vue&type=script&lang=js"
export * from "./ApplicationHotspot.vue?vue&type=script&lang=js"

import "./ApplicationHotspot.vue?vue&type=style&index=0&id=707e1cfa&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__